import React from 'react';
import Rooms from './Rooms';

const RoomsList = ( { Esrooms, toggleModal } ) => {		
	return (
		<div>
			{
			Esrooms.map( (user, i) => {
				return( 
					<Rooms 
						key={Esrooms[i].id} 
						id ={Esrooms[i].id}
						company ={Esrooms[i].company} 
						name = {Esrooms[i].name}
						image = {Esrooms[i].image}
						playedon = {Esrooms[i].playedon}
						toggleModal = {toggleModal}						
					/>
					);	
				})
			}		
		</div>
	)	
}

export default RoomsList


// WEBPACK FOOTER //
// ./src/Rooms/RoomsList.js